import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createRegistrationToken } from '~/services/AgentHub/AgentService';

interface CreateRegistrationTokenParams {
  agentId: string;
  expiresAt: string;
}

export function useCreateRegistrationToken() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ agentId, expiresAt }: CreateRegistrationTokenParams) => {
      return await createRegistrationToken(agentId, { expiresAt });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['registration-tokens'] });
    },
  });
}
